import { render, staticRenderFns } from "./SemVinculo.vue?vue&type=template&id=17c67cdf&scoped=true&"
import script from "./SemVinculo.vue?vue&type=script&lang=js&"
export * from "./SemVinculo.vue?vue&type=script&lang=js&"
import style0 from "./SemVinculo.vue?vue&type=style&index=0&id=17c67cdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c67cdf",
  null
  
)

export default component.exports